import React from 'react';
import { ResultTableTitle } from './ReportEffectOpenComments.styles';
import { useReportContext } from '../../../../hooks/useReport';
import EffectOpenCommentsTemplate from '../../SharedEffectReportComponents/EffectOpenCommentsTemplate/EffectOpenCommentsTemplate';

const ReportEffectOpenComments = () => {
  const { openQuestions } = useReportContext();

  return (
    <ResultTableTitle>
      {openQuestions?.analysis.map(item => {
        const data =
          item.type === 'EFFECT OPEN QUESTIONS' ? openQuestions.internal : openQuestions.external;

        return data.length > 0 ? (
          <EffectOpenCommentsTemplate key={item.description} analysis={item} data={data} />
        ) : null;
      })}
    </ResultTableTitle>
  );
};

export default ReportEffectOpenComments;
